import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.function.name.js";
import dayjs from 'dayjs';
import { Environment } from 'utils/deploymentInfo';
import fetchAPI from 'utils/http/fetchAPI';
// Disable unique keys to reallow reuse of work results in development
var DISABLE_UNIQUE_KEYS = ['GetEmbedding'];
var getCacheUniquenessKey = function getCacheUniquenessKey(taskName, environment) {
  // Disable cache in development or if localStorage says so
  // Do not disable for embeddings requests because download seurat & trajectory depend on that ETag
  if (environment !== Environment.PRODUCTION && localStorage.getItem('disableCache') === 'true' && !DISABLE_UNIQUE_KEYS.includes(taskName)) {
    return Math.random();
  }
  return null;
};
var getWorkerTimeout = function getWorkerTimeout(taskName, defaultTimeout) {
  switch (taskName) {
    case 'GetEmbedding':
    case 'ListGenes':
    case 'MarkerHeatmap':
      {
        return dayjs().add(1800, 's').toISOString();
      }
    default:
      {
        return dayjs().add(defaultTimeout, 's').toISOString();
      }
  }
};
var dispatchWorkRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(experimentId, body, timeout, requestProps, getState) {
    var taskName, workerTimeoutDate, requestTime, environment, cacheUniquenessKey, request, _yield$fetchAPI, _yield$fetchAPI$data, ETag, signedUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            taskName = body.name; // for listGenes, markerHeatmap, & getEmbedding we set a long timeout for the worker
            // after that timeout the worker will skip those requests
            // meanwhile in the UI we set a shorter timeout. The UI will be prolonging this timeout
            // as long as it receives "heartbeats" from the worker because that means the worker is alive
            // and progresing.
            // this should be removed if we make each request run in a different worker
            workerTimeoutDate = getWorkerTimeout(taskName, timeout);
            requestTime = dayjs().toISOString();
            environment = getState().networkResources.environment;
            cacheUniquenessKey = getCacheUniquenessKey(taskName, environment); // eslint-disable-next-line no-param-reassign
            requestProps.cacheUniquenessKey = cacheUniquenessKey;
            request = {
              experimentId: experimentId,
              timeout: workerTimeoutDate,
              requestTime: requestTime,
              body: body,
              requestProps: requestProps
            };
            _context.next = 9;
            return fetchAPI("/v2/workRequest/".concat(experimentId), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(request)
            });
          case 9:
            _yield$fetchAPI = _context.sent;
            _yield$fetchAPI$data = _yield$fetchAPI.data;
            ETag = _yield$fetchAPI$data.ETag;
            signedUrl = _yield$fetchAPI$data.signedUrl;
            return _context.abrupt("return", {
              ETag: ETag,
              signedUrl: signedUrl,
              request: request
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function dispatchWorkRequest(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
export default dispatchWorkRequest;